// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__hU8Zm","buttons":"RemoveExpirationActionButtons_buttons__3pXur"};